/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

import { useLanguage } from '@/providers/LanguageProvider';

type KahuMinimizedProps = {
  unreadCount: number;
};

export const KahuMinimized = ({ unreadCount }: KahuMinimizedProps) => {
  const { messages } = useLanguage();
  const KahuAiString = messages?.KahuAI;

  return (
    <div className="relative h-auto w-[260px] cursor-pointer rounded-lg border border-[#34bcaf] bg-canvas-background-secondary p-4 pt-6">
      <div
        className="absolute right-4 top-full h-[7px] w-[15px] bg-[#34BCAF]
  [clip-path:polygon(50%_100%,_0_0,_100%_0)]"
      ></div>
      <div className="flex flex-col items-center justify-center gap-2">
        <p className="text-center text-h4 font-bold text-white">
          {KahuAiString?.hey_im_kahu}
        </p>
        <p className="text-center text-body-sm font-normal tracking-[2%] text-body-subtle">
          {` I got ${unreadCount} unread responses. Click to continue the conversation.`}
        </p>
      </div>
    </div>
  );
};
